import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import './app.scss';
import AppRoutes from './Routes';
import * as serviceWorker from './serviceWorker';
import { Provider as ReduxProvider } from 'react-redux';
import storeSingleton from './config/store/store';
import 'core-js/modules/es7.array.includes';
import 'core-js/modules/es6.array.fill';
import 'core-js/modules/es6.string.includes';
import 'core-js/modules/es6.string.trim';
import 'core-js/modules/es7.object.values';
import { initGA4 } from './analytics/ga4';

const store = storeSingleton();

createRoot(document.getElementById('root')).render(
  <ReduxProvider store={store}>
    <AppRoutes />
  </ReduxProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
initGA4();